<template>
  <v-container v-if="dataindicador !== null" grid-list-xl>
    <div class="vue-contentido">
      <v-toolbar flat color="primary">
        <div class="text-white">{{dataindicador.codigo}} - {{dataindicador.nombre}}</div>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                x-large
                color="white"
                v-on="on"
                @click="SaveHito"
                :disabled="buttonguardarestado"
              >
                <v-icon>save</v-icon>
              </v-btn>
            </template>
            <span>Guardar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                x-large
                color="white"
                v-on="on"
                @click="FinalizarHito"
                :disabled="buttonfinalizarestado"
              >
                <v-icon>send</v-icon>
              </v-btn>
            </template>
            <span>Finalizar</span>
          </v-tooltip>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider></v-divider>
    </div>

    <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left"  icons-and-text background-color="blue-grey lighten-4">
      <v-tabs-slider></v-tabs-slider>
      <v-tab>
        Avances
        <v-icon>mdi-file-alert</v-icon>
      </v-tab>
      <v-tab>
        Historico
        <v-icon>history</v-icon>
      </v-tab>
      <v-tab>
        Detalle Indicador
        <v-icon>dialpad</v-icon>
      </v-tab>

      <v-tab-item>
        <v-card :elevation="2" :loading="loading" :disabled="loading">
          <v-textarea v-model="datahito.descripcion" label="Descripción:" :disabled="true"></v-textarea>
          <v-card-text active-class="deep-purple accent-4 white--text">
            <v-layout row wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  :disabled="true"
                  v-model="datahito.ponderacion"
                  label="Porcentaje de ponderacion "
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  :disabled="true"
                  :value="formato(datahito.fechacumplimiento)"
                  label="Fecha de cumplimiento "
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                Hay cumplimiento del Hito *
                <v-radio-group
                  row
                  v-model="hitocumplido"
                  :readonly="readcontrol('cumplimientohito')"
                  @change="cambiocumplimientohito"
                >
                  <v-radio label="si" :value="true"></v-radio>
                  <v-radio label="no" :value="false"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <!-- <v-textarea
                  label="Observaciones"
                  :counter="4000"
                  :disabled="!hitocumplido"
                  v-model="datahito.observacion"
                  v-validate="'max:4000'"
                  data-vv-name="observaciones"
                  :error-messages="errors.collect('observaciones')"
                  :readonly="readcontrol('observaciones')"
                ></v-textarea> -->
                <label for="observaciones" class="form-label">Observaciones</label>
                <quill-editor
                  ref="observaciones"
                  id="observaciones"
                  :disabled="(hitocumplido == false) || (readcontrol('observaciones') == true)"
                  v-model="datahito.observacion"
                  data-vv-name="observaciones"
                  :error-messages="errors.collect('observaciones')"
                  :options="editorOptionsObservaciones"
                  @ready="onEditorReady($event)"
                />
                <div id="counter" class="counter"></div>
              </v-flex>
              <v-layout row wrap>
                <v-flex xs12 sm2 md2>
                  <v-checkbox
                    v-model="hitoenespera"
                    label="Llenar despúes"
                    :disabled="llenarDespuesDeshabilitado"
                    :readonly="readcontrol('incumplimiento')"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm10 md10>
                  <!-- <v-textarea
                    label="Razones del incumplimiento"
                    :counter="4000"
                    :disabled="hitocumplido"
                    v-model="datahito.incumplimiento"
                    v-validate="'max:4000'"
                    data-vv-name="incumplimiento"
                    :error-messages="errors.collect('incumplimiento')"
                    :readonly="readcontrol('incumplimiento')"
                  ></v-textarea> -->
                  <label for="razonincumplimiento" class="form-label">Razones del incumplimiento</label>
                  <quill-editor
                    ref="razonincumplimiento"
                    id="razonincumplimiento"
                    :disabled="(hitocumplido == true) || (readcontrol('incumplimiento') == true)"
                    v-model="datahito.incumplimiento"
                    data-vv-name="incumplimiento"
                    :error-messages="errors.collect('incumplimiento')"
                    :options="editorOptionsRazonInumplimiento"
                    @ready="onEditorReady($event)"
                  />
                  <div id="counter2" class="counter"></div>
                </v-flex>
              </v-layout>

              <v-flex xs12 sm12>
                <p class="font-weight-light">Gestión de soportes.</p>
                <v-flex row>
                  <v-flex sm5 md5></v-flex>
                  <v-flex sm5 md5>
                    <template>
                      <v-file-input
                        accept=".pdf, .xlsx, .xls"
                        v-model="file"
                        show-size
                        multiple
                        label="Cargar archivo"
                        @change="onSoporteChange"
                      ></v-file-input>
                    </template>
                  </v-flex>
                  <v-flex sm2 md2 v-show="showcontrol('agregarsoporte')">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="ma-2"
                          v-on="on"
                          @click="Addsoporte"
                          :disabled="readcontrol('agregarsoporte')"
                          title
                          outlined
                          color="success"
                        >
                          <v-icon left>add</v-icon>Agregar
                        </v-btn>
                      </template>
                      <span>Agregar archivo</span>
                    </v-tooltip>
                  </v-flex>
                </v-flex>
                <v-data-table
                  :headers="headersoporte"
                  :items="soporteshito"
                  class="elevation-1"
                  :items-per-page="100"
                  hide-default-footer
                  :no-data-text="gnodata"
                >
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          small
                          class="mr-2"
                          @click="deletesoporte(item)"
                          :disabled="readcontrol('eliminarsoporte')"
                        >delete</v-icon>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          small
                          class="mr-2"
                          @click="descargarsoporte(item)"
                        >mdi-file</v-icon>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <historico :idtabla="5" :idelemento="datahito.idhito"></historico>
      </v-tab-item>

      <v-tab-item>
        <v-form class="container" v-if="ValueIndicador !== null">
          <br />
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-text-field v-model="valpunto.nombre" label="punto:" :disabled="true"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12>
              <v-textarea v-model="valpilar.nombre" label="pilar:" :disabled="true"></v-textarea>
            </v-flex>

            <v-flex xs12 sm12>
              <v-text-field v-model="valestrategia.nombre" label="estrategia:" :disabled="true"></v-text-field>
            </v-flex>

            <v-flex xs12 sm12>
              <v-text-field v-model="vallinea.nombre" label="línea de acción:" :disabled="true"></v-text-field>
            </v-flex>

            <v-flex xs12 sm12>
              <v-textarea v-model="valpnavigation.nombre" label="producto:" :disabled="true"></v-textarea>
            </v-flex>

            <v-flex xs12 sm12>
              <v-text-field
                v-model="dataindicador.codigo"
                label="código del indicador:"
                :disabled="true"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12>
              <v-textarea v-model="dataindicador.nombre" label="indicador:" :disabled="true"></v-textarea>
            </v-flex>

            <v-flex xs12 sm6>
              <v-text-field v-model="dataindicador.inicio" label="fecha inicio:" :disabled="true"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6>
              <v-text-field v-model="dataindicador.fin" label="fecha fin:" :disabled="true"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6>
              <v-text-field v-model="valsectores.nombre" label="sector:" :disabled="true"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6>
              <v-text-field
                v-model="valentidades.nombre"
                label="entidad responsable:"
                :disabled="true"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12>
              <v-text-field
                v-model="valclasificacion.nombre"
                label="clasificador pmi:"
                :disabled="true"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-tab-item>
    </v-tabs>

    <v-divider></v-divider>
    <v-flex xs12 sm12 v-show="controlrevision('comentariohito')">
      <v-card tile :loading="loading">
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>Revisión del Indicador ({{dataindicador.codigo}})</v-toolbar-title>
          <div class="flex-grow-1"></div>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 sm12>
            <!-- <v-textarea
              v-validate="'max:4000'"
              data-vv-name="revisioncomentario"
              :error-messages="errors.collect('revisioncomentario')"
              :counter="4000"
              v-model="datahito.comentariohito"
              label="Comentario:"
              :disabled="readcontrol('comentariohito')"
            ></v-textarea> -->
            <label for="avancecualitativo" class="form-label">Comentario:</label>
            <quill-editor
              ref="revisioncomentario"
              id="revisioncomentario"
              v-model="datahito.comentariohito"
              label="Comentario:"
              :disabled="readcontrol('comentariohito') == true"
              :options="editorOptionsRevisionComentario"
              @ready="onEditorReady($event)"
              @change="onEditorChange($event)"
            />
            <div id="counter3" class="counter"></div>
          </v-flex>
          <v-flex row>
            <v-flex xs6 sm6></v-flex>
            <v-flex xs6 sm6>
              <v-select
                :items="dropdown_comment"
                v-model="datahito.hitoaprobado"
                item-text="text"
                item-value="value"
                label="Seleccione opción"
              ></v-select>
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-speed-dial
      fixed
      :top="false"
      :bottom="true"
      :right="true"
      :left="false"
      direction="left"
      :open-on-hover="true"
      transition="scale-transition"
    >
      <template v-slot:activator>
        <v-btn fab color="blue-grey lighten-3">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small color="green" @click="SaveHito" v-show="!buttonguardarestado">
        <v-icon>save</v-icon>
      </v-btn>
      <v-btn fab dark small color="green" @click="FinalizarHito" v-show="!buttonfinalizarestado">
        <v-icon>send</v-icon>
      </v-btn>
    </v-speed-dial>

    <v-snackbar v-model="snack" :timeout="timeoutsnak" :color="MesaggeInfo.color">
      {{this.MesaggeInfo.codigoRespuesta}}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="functionalert">{{buttontext}}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../../stores/index.js";
import moment from "moment";
import historico from "../../components/content/historico";
import { ErrorBag } from 'vee-validate';
import 'quill/dist/quill.core.css'; // import styles
import 'quill/dist/quill.snow.css'; // for snow theme
import { quillEditor } from 'vue-quill-editor';
import Counter from "../../components/global/counter.js";
import Quill from 'quill';
var Delta = Quill.import('delta');
Quill.register('modules/counter', Counter);

export default {
  name: "reporteavancehitos",
  data() {
    return {
      //data generic
      ValueIndicador: [],
      valpunto: [],
      valpilar: [],
      vallinea: [],
      valestrategia: [],
      valpnavigation: [],
      valsectores: [],
      valentidades: [],
      valclasificacion: [],
      estrategia: [],
      dataindicador: [],
      datahito: [],
      hitocumplido: true,
      hitoenespera: false,
      usuarioregistrado: [],
      userautenticado: false,
      idindicador: null,
      buttonguardarestado: true,
      buttonfinalizarestado: true,
      loading: false,
      llenarDespuesDeshabilitado: false,
      estadocampos: [],
      estadocamposindicador: [],
      dropdown_comment: [
        { text: "Aprobar", value: true },
        { text: "Rechazar", value: false }
      ],

      //soportes
      file: null,
      imageUrl: null,
      soporte: {
        nombrearchivo: "",
        tipoarchivo: "",
        idavancecualitativo: 0,
        archivocompleto: "",
        filefull: []
      },
      soporteshito:[],
      deletesoportes: [],
      headersoporte: [
        { text: "nombre archivo", value: "nombrearchivo", align: "center" },
        { text: "tipo archivo", value: "tipoarchivo", align: "center" },
        { text: "Acciones", value: "action", sortable: false }
      ],
      //campos del cuadro de dialog de mensajes
      snack: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      timeoutsnak: 4000,
      buttontext: "cerrar",

      //validacion de idsfinalizados
      timewait: 3,
      HitoFiltrado: [],

      //Validacion de campos
      dictionary: {
        custom: {
          observaciones: {
            max: "esta superando el limite de caracteres"
          },
          incumplimiento: {
            max: "esta superando el limite de caracteres"
          },
          cumplido: {
            required: () =>
              "Es obligatorio seleccionar si se da o no el cumplimiento del Hito"
          },
          revisioncomentario: {
            max: "esta superando el limite de caracteres"
          }
        }
      },
      reglasarchivocarga: [
        value =>
          !value ||
          value.size < 5000000 ||
          "El archivo no puede ser mayor a 5 megas!"
      ],
      quill: null,
      editorOptionsObservaciones: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline','strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
               [{ 'indent': '-1'}, { 'indent': '+1' }],
            ],
          },
          counter: {
            container: '#counter',
            controlContainer: '#observaciones',
            unit: 'letra',
            max: 8000
          },
          clipboard: {
            matchers: [
              [ Node.ELEMENT_NODE, function(node, delta) {
                return delta.compose(new Delta().retain(delta.length(), 
                { 
                  align: "justify",
                  link: false,
                  color: false,
                  size:"10px",
                  header: false
                }
                ));
                }
              ] 
            ]
				  }
        },
        placeholder: ''
      },
      editorOptionsRazonInumplimiento: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline','strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
               [{ 'indent': '-1'}, { 'indent': '+1' }],
            ],
          },
          counter: {
            container: '#counter2',
            controlContainer: '#razonincumplimiento',
            unit: 'letra',
            max: 8000
          },
          clipboard: {
            matchers: [
              [ Node.ELEMENT_NODE, function(node, delta) {
                return delta.compose(new Delta().retain(delta.length(), 
                { 
                  align: "justify",
                  link: false,
                  color: false,
                  size:"10px",
                  header: false
                }
                ));
                }
              ] 
            ]
				  }
        },
        placeholder: ''
      },
      editorOptionsRevisionComentario: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline','strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
               [{ 'indent': '-1'}, { 'indent': '+1' }],
            ],
          },
          counter: {
            container: '#counter3',
            controlContainer: '#revisioncomentario',
            unit: 'letra',
            max: 8000
          },
          clipboard: {
            matchers: [
              [ Node.ELEMENT_NODE, function(node, delta) {
                return delta.compose(new Delta().retain(delta.length(), 
                { 
                  align: "justify",
                  link: false,
                  color: false,
                  size:"10px",
                  header: false
                }
                ));
                }
              ] 
            ]
				  }
        },
        placeholder: ''
      }
    };
  },
  components: {
    historico,
    quillEditor
  },
  methods: {
    ...mapActions([
      "gethitobyid",
      "get_camposestado",
      "get_camposestadosecundary",
      "get_historicotareas",
      "downloadsoporte",
      "getsoportesHitos",
      "PostHito",
      "get_configuraciones"
    ]),
    ...mapActions("usuario/", ["get_usuarios"]),
    ...mapActions("carga/", ["post_cargararchivote"]),
    onEditorReady(quill) {
      quill.format('align', 'justify');
    },
    onEditorChange({ quill }) {
        quill.getModule('counter').update();
    },
    getusuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
    errortemporal() {
      this.snack = true;
      this.MesaggeInfo.mensajeRespuesta =
        "Existe una problema en el cargue de los archivos. Intente reducir el número de archivos a guardar.";
      this.MesaggeInfo.color = "warnvue";
    },
    cambiocumplimientohito(){
      if(this.hitocumplido === false)
      {
        this.hitoenespera = true;
        this.llenarDespuesDeshabilitado = true;
      }
      else
      {
        this.hitoenespera = false;
        this.llenarDespuesDeshabilitado = false;
      }
      console.log(this.hitoenespera);
    },
    //procesos generales
    async SaveHito() {
      this.loading = true;
      let bytes = window.crypto.getRandomValues(new Uint8Array(32));
      const randomBytes = () => (bytes = bytes.slice(1)) && bytes[0];
      let tran = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ (randomBytes() & (15 >> (c / 4)))).toString(16)
      );
      //setTimeout(() => (this.loading = false), 10000)
      this.datahito.transaccion = tran;

      this.datahito.cumplido = this.hitocumplido;
      if (!this.hitocumplido) {
        if (this.hitoenespera == null) this.hitoenespera = false;
      }
      this.datahito.enespera = this.hitoenespera;

      if (this.soporte != null) {
        // this.datahito.soporte = this.gsoportehito;
      } else {
        this.datahito.soporte = null;
      }

      this.datahito.soportedelete = this.deletesoportes;
      this.dataindicador.hito[0] = this.datahito;
      let errorcarga = false;
      if (this.soporte != null) {
        await this.post_cargararchivote({
          archivo: this.soporteshito,
          idtransaccion: tran,
          tamanopaquete: this.tamanopaquete
        });
        errorcarga = this.gerrorcarga;
      }
      if (errorcarga === false) {
        if (this.datahito.idestado == 3 && this.datahito.finalizar) {
          if (this.datahito.hitoaprobado == null) {
            this.snack = true;
            this.MesaggeInfo.mensajeRespuesta =
              "debe aprobar o rechazar el indicador";
            this.MesaggeInfo.color = "infovue";
            this.loading = false;
            return;
          }
          if (this.datahito.comentariohito == null) {
            this.snack = true;
            this.MesaggeInfo.mensajeRespuesta =
              "El comentario del indicador no puede estar vacio";
            this.MesaggeInfo.color = "infovue";
            this.loading = false;
            return;
          }
          if (this.datahito.comentariohito.length == 0) {
            this.snack = true;
            this.MesaggeInfo.mensajeRespuesta =
              "El comentario del indicador no puede estar vacio";
            this.MesaggeInfo.color = "infovue";
            this.loading = false;
            return;
          }
        }

        this.PostHito({
          data: this.dataindicador
        });
        this.deletesoportes = [];
      } else {
        this.errortemporal();
      }
    },
    FinalizarHito() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.dataindicador.finalizar = true;
          this.datahito.finalizar = true;
          this.SaveHito();
          this.marcarfinalizado();
          return;
        }
        console.log(this.$validator);
        this.snack = true;
        this.MesaggeInfo.mensajeRespuesta =
          "la validación del formulario contiene errores";
        this.MesaggeInfo.color = "infovue";
      });
    },
    ValidarCamposTextoEnriquecido(){
      let bag = new ErrorBag();
        bag = this.errors;
        if(bag.first('observaciones') !== undefined)
          bag.removeById(bag.first('observaciones').id);

        if( this.$refs.observaciones.quill.root.innerHTML.length > this.$refs.observaciones.quill.options.modules.counter.max  && bag.first('observaciones') == undefined)
        {
          bag.add({
              field: 'observaciones',
              msg: 'está superando el límite de caracteres'
          });
        }

        if(bag.first('razonincumplimiento') !== undefined)
          bag.removeById(bag.first('razonincumplimiento').id);

        if( this.$refs.razonincumplimiento.quill.root.innerHTML.length > this.$refs.razonincumplimiento.quill.options.modules.counter.max  && bag.first('razonincumplimiento') == undefined)
        {
          bag.add({
              field: 'razonincumplimiento',
              msg: 'está superando el límite de caracteres'
          });
        }

        if(bag.first('revisioncomentario') !== undefined)
          bag.removeById(bag.first('revisioncomentario').id);

        if( this.$refs.revisioncomentario.quill.root.innerHTML.length > this.$refs.revisioncomentario.quill.options.modules.counter.max  && bag.first('revisioncomentario') == undefined)
        {
          bag.add({
              field: 'revisioncomentario',
              msg: 'está superando el límite de caracteres'
          });
        }

       //revisioncomentario 
    },
    readcontrol(control) {
      if (this.estadocampos.length > 0) {
        let responseread = this.estadocampos.find(function(element) {
          if (element.nombre == control) {
            return element;
          }
        });
        if (responseread == null) return true;
        else return responseread.lectura;
      }
    },
    controlrevision(control) {
      let mostrar1 = this.showcontrol(control);
      let mostrar = false;      
      if (mostrar1 !== undefined) {        
        mostrar = this.buttonguardarestado === false && mostrar1.visible === true;
      }      
      return mostrar;
    },
    showcontrol(control) {
      if (this.estadocampos.length > 0) {
        let responsefound = this.estadocampos.find(function(element) {
          if (element.nombre == control) {
            return element.visible;
          }
        });
        return responsefound;
      }
    },
    readcontrolindicador(control) {
      if (this.estadocamposindicador.length > 0) {
        let responseread = this.estadocamposindicador.find(function(element) {
          if (element.nombre == control) {
            return element;
          }
        });
        if (responseread == null) return true;
        else return responseread.lectura;
      }
    },
    showcontrolindicador(control) {
      if (this.estadocamposindicador.length > 0) {
        let responsefound = this.estadocamposindicador.find(function(element) {
          if (element.nombre == control) {
            return element.visible;
          }
        });
        return responsefound;
      }
    },
    functionalert() {
      if (this.buttontext == "cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "aceptar") {
        this.buttontext == "cerrar";
        this.snack = false;
        this.timeoutsnak = 4000;
        let ruta = localStorage.pathfrom;
        this.$router.push(ruta);
      }
    },
    usuario(idusuario) {
      if (this.gusuarios !== undefined)
        return this.gusuarios.filter(p => p.idusuario === idusuario)[0].login;
      else return "Anonimo";
    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },

    //soportes ********************************************************************
    Addsoporte() {
      if (this.file !== null) {
        if (this.file.size > 5000000) {
          this.MesaggeInfo.mensajeRespuesta =
            "El tamaño del archivo supera el limite de carga (5 Mb)";
          this.MesaggeInfo.color = "errorvue";
          this.snack = true;
        } else {
          if (this.file !== null) {
            for (let i = 0; i < this.file.length; i++) {
              let file = this.file[i];
              this.soporte = Object.assign({}, this.soporteshito);
              this.soporte.nombrearchivo = file.name;
              this.soporte.tipoarchivo = file.type;
              this.soporte.idavance = this.selectedcualitativo;
              this.soporte.finalizado = false;
              this.soporte.archivocompleto = this.imageUrl[i];
              this.soporte.idsoporte = 0;
              this.soporteshito.push(this.soporte);
            }
            this.imageUrl = [];
            this.file = [];
          } else {
            this.MesaggeInfo.mensajeRespuesta =
              "Seleccione un archivo para la carga";
            this.MesaggeInfo.color = "infovue";
            this.snack = true;
          }
        }
      } else {
        this.MesaggeInfo.mensajeRespuesta =
          "Seleccione un archivo para la carga";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
      }
    },
    onSoporteChange() {
      this.imageUrl = [];
      let error = false;
      if (this.file !== null) {
        for (let i = 0; i < this.file.length; i++) {
          if (error === false) {
            let filet = this.file[i];
            let tipo = filet.type.replace("application/", "");
            if (this.tiposarchivo.indexOf(tipo, 0) > 0) {
              if (filet.size > this.tamanoarchivo * 1024000) {
                this.MesaggeInfo.mensajeRespuesta =
                  "El tamaño de uno de los archivos supera el límite de carga (" +
                  this.tamanoarchivo +
                  "Mb)";
                this.MesaggeInfo.color = "errorvue";
                this.snack = true;
                error = true;
              } else {
                let actual = this.soporteshito.filter(
                  p => p.nombrearchivo === filet.name
                )[0];
                if (actual === undefined) {
                  let reader = new FileReader();
                  reader.onload = () => {
                    this.imageUrl.push(reader.result);
                  };
                  reader.readAsDataURL(filet);
                } else {
                  this.MesaggeInfo.mensajeRespuesta =
                    "Uno de los archivos ya se encuentra relacionado en el reporte";
                  this.MesaggeInfo.color = "errorvue";
                  this.snack = true;
                  error = true;
                }
              }
            } else {
              this.MesaggeInfo.mensajeRespuesta =
                "Uno de los archivos no es compatible con los tipos permitidos";
              this.MesaggeInfo.color = "errorvue";
              this.snack = true;
              error = true;
            }
          }
        }
        if (error === true) {
          this.imageUrl = [];
          this.file = [];
        }
      }
    },
    deletesoporte(item) {
      const index = this.soporteshito.indexOf(item);
      if (confirm("Desea eliminar el soporte?")) {
        this.deletesoportes.push(item);
        this.soporteshito.splice(index, 1);
      }
    },
    descargarsoporte(item) {
      if (item.archivocompleto == null) {
        this.downloadsoporte({
          params: {
            idindicador: this.dataindicador.idindicador,
            idsoporte: item.idsoporte
          }
        });
      } else {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = item.archivocompleto;
        a.setAttribute("download", item.nombrearchivo);
        a.click();
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      }
    },
    marcarfinalizado() {
      // Estas lineas de codigo se utilizan para generar un temporal del indicador finalizado
      //================================================
      let ahora = new Date();
      let ahorafilter = new Date();
      ahorafilter.setMinutes(ahorafilter.getMinutes() - this.timewait);
      ahorafilter = new Date(ahorafilter);
      this.HitoFiltrado.push({
        idhito: this.datahito.idhito,
        fecha: ahora
      });
      localStorage.setItem("HitoFiltrado", JSON.stringify(this.HitoFiltrado)
      );
      //===================================================
    },
    EliminarFinalizado() {
      // Estas lineas de codigo se utilizan para generar un temporal del indicador finalizado
      //================================================
      this.HitoFiltrado.forEach(element => {
        if (this.datahito.idhito == element.idhito) {
          const index = this.HitoFiltrado.indexOf(element);
          this.HitoFiltrado.splice(index, 1);
        }
      });
      localStorage.setItem("HitoFiltrado",JSON.stringify(this.HitoFiltrado)
      );
      //===================================================
    },
    getIDfinalizados() {
      let vfiltro = localStorage.HitoFiltrado;
      if (vfiltro !== undefined) {
        this.HitoFiltrado = JSON.parse(unescape(vfiltro));
      }
      //validamos que no hayan dado F5 despues de haber dado finalizar
      if (this.HitoFiltrado != undefined) {
        let GetCurrentIndicador = this.HitoFiltrado.filter(
          X => X.idhito == this.datahito.idhito
        );
        if (GetCurrentIndicador != undefined) {
          if (GetCurrentIndicador.length > 0) {
            let mensajealerta = "El hito " + this.datahito.idhito + " ya fue finalizado y esta siendo procesado";
            console.log(mensajealerta);
            this.snack = true;
            this.MesaggeInfo.mensajeRespuesta = mensajealerta;
            this.MesaggeInfo.color = "infovue";
            let ruta = "/tareas";
            this.$router.push(ruta);
          }
        }
      }
    }
  },
  created() {
    this.get_usuarios();
    let user = this.getusuario();
    let auten = user.token.replace("Bearer ", "");
    this.$aes.setKey(auten);
    let temporal = this.$route.params.idhito.replace(/AbcYq/g, "/");
    temporal = temporal.replace(/qYcbA/g, "+");
    temporal = this.$aes.decrypt(temporal);
    temporal = temporal.substring(4);
    temporal = temporal.substring(0, temporal.length - 4);
    temporal = this.$aes.decrypt(temporal);
    this.idindicador = temporal;
    this.get_configuraciones();
    this.gethitobyid({
      params: {
        idhito: this.idindicador
      }
    });
  },
  computed: {
    ...mapGetters([
      "gindicadorhito",
      "gsoportehito",
      "gcampos",
      "gcampossecundary",
      "gtareascerradas",
      "gconfiguraciones"
    ]),
    ...mapGetters("usuario", ["gusuario", "gusuarios"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("carga", ["gerrorcarga"])
  },
  watch: {
    gindicadorhito: function() {
      this.dataindicador = this.gindicadorhito;

      this.datahito = this.gindicadorhito.hito[0];
      this.hitocumplido = this.datahito.cumplido;

      this.hitoenespera = this.datahito.enespera;
    },
    dataindicador: function(val) {
      this.ValueIndicador = val;
      this.valpunto = val.punto;
      this.valpilar = val.pilar;
      this.valestrategia = val.estrategia;
      this.vallinea = val.linea;
      this.valpnavigation = val.idproductoNavigation;
      this.valsectores = val.sectores;
      this.valentidades = val.entidades;
      this.valclasificacion = val.idclasificacionNavigation;

      this.get_camposestadosecundary({
        params: {
          idtabla: "indicador",
          idestado: val.idestado
        }
      });
      this.getIDfinalizados();
    },
    datahito: function(val) {
      // Proceso que establece el estado de los botones ****************************************
      this.usuarioregistrado = this.getusuario();
      if (val.idusuarioresponsable !== null) {
        if (val.idusuarioresponsable == this.usuarioregistrado.idusuario) {
          this.userautenticado = true;
        }
      }

      if (val.idrolresponsable !== null && this.userautenticado == false) {
        this.usuarioregistrado.usuarioRol.forEach(element => {
          if (element.idrol == val.idrolresponsable) {
            this.userautenticado = true;
          }
        });
      }

      if (this.userautenticado) {
        this.buttonfinalizarestado = false;
        this.buttonguardarestado = false;
      }
      // ****************************************

      this.getsoportesHitos({
        params: {
          idhito: val.idhito
        }
      });
      this.get_camposestado({
        params: {
          idtabla: "AvanceHito",
          idestado: val.idestado
        }
      }),
        this.get_historicotareas({
          params: {
            idtabla: "4",
            idelemento: val.idhito
          }
        });
    },
    gcampos() {
      this.estadocampos = this.gcampos;
    },
    gcampossecundary() {
      this.estadocamposindicador = this.gcampossecundary;
    },
    ginformation() {
      if (this.loading) {
        if (this.ginformation.idGenerado == "1") {
          //esta linea es un guardado existoso
          this.soporte = null;
          this.getsoportesHitos({ params: { idhito: this.datahito.idhito } });
        }
        if (this.datahito.finalizar) {
          this.buttonguardarestado = true;
          this.buttonfinalizarestado = true;
          this.buttontext = "aceptar";
          this.timeoutsnak = 0;
          this.snack = true;
          this.MesaggeInfo.mensajeRespuesta =
            "El proceso del indicador a finalizado; presione aceptar para continuar";
          this.MesaggeInfo.color = "infovue";
        } else {
          this.EliminarFinalizado();
          this.MesaggeInfo = this.ginformation;
          this.snack = true;
          //este console por favor dejarlo, es para que el usuario tenga en consola los posibles mensajes por si no alcanza a leerlo
          console.log(this.MesaggeInfo.mensajeRespuesta);
        }
        this.loading = false;
        store.dispatch("mensaje/set_reset");
      }
    },
    hitocumplido(val) {
      if (val) {
        this.datahito.incumplimiento = "";
        this.hitoenespera = null;
      } else {
        this.datahito.observacion = "";
      }
    },
    gconfiguraciones() {
      this.tiposarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TiposArchivo"
      )[0].valor;
      this.tamanoarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoArchivo"
      )[0].valor;
      this.tamanopaquete = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoPaquete"
      )[0].valor;
      let GetConfigtime = this.gconfiguraciones.filter(X => X.codigo == "TiempoEspera")[0];
      if (GetConfigtime != undefined)
      {
        this.timewait = GetConfigtime.valor;
      }
    },
    gsoportehito(){
      this.soporteshito = this.gsoportehito;
    }
  }
};
</script>
<style>

</style>